export enum NarratorBlockTypes {
  BODY_ANIMATION = 'BodyAnimation',
  HEAD_ANIMATION = 'HeadAnimation',
  SPEECH = 'Speech',
  READ_QUESTION = 'ReadQuestion',
  REFLECTION = 'Reflection',
  REFLECTION_FORMULA = 'ReflectionFormula',
  PAUSE = 'Pause',
  FEEDBACK = 'Feedback',
}
